import React, {useContext, useMemo} from 'react';
import {useFormikContext} from 'formik';
import {BaseForm} from 'src/types/onboarding';
import BaseStep from 'shared/registration/components/steps/base-step';
import FooterTextWithEmoji from 'shared/student/registration/components/footer-text-with-emoji';
import AchievementCards from './AchievementCards';
import {Emojis} from 'src/types/enums';
import {ObjectOf} from 'src/types/store';
import {useMediaQuery} from 'src/hooks/useMediaQuery';
import {ImpostorModeContext} from 'src/components/ImpostorModeContext';

function getText(
  isXSView: boolean,
  firstName: string,
  isImpostor: boolean
): ObjectOf<React.ReactElement | string> {
  let title, subtitle, footerText;

  if (isXSView) {
    title = [
      `What ${isImpostor ? `has ${firstName}` : 'have you'} done`,
      <br key="title-break" />,
      'in high school?',
    ];

    subtitle = [
      `See how much ${isImpostor ? `${firstName} earns` : 'you earn'} for`,
      <br key="subtitle-break" />,
      `things ${isImpostor ? 'they' : 'you'} already do`,
    ];

    footerText = [
      'And hundreds of more things',
      <br key="footer-text-break" />,
      `${isImpostor ? firstName : 'you'} can earn micro-scholarships for!`,
    ];
  } else {
    title = `What ${isImpostor ? `has ${firstName}` : 'have you'} done in high school?`;
    subtitle = `See how much ${isImpostor ? 'your child earns' : 'you earn'} for things
                    ${isImpostor ? 'they' : 'you'} already do`;
    footerText = `And hundreds of more things ${
      isImpostor ? firstName : 'you'
    } can earn micro-scholarships for!`;
  }

  return {
    title,
    subtitle,
    footerText,
    disclaimer: 'Average Award Amount',
  };
}

export default function AchievementSelection(): React.ReactElement {
  const form = useFormikContext<BaseForm>();
  const impostorModeContext = useContext(ImpostorModeContext);
  const {firstName} = form.values;
  const mq = useMediaQuery();
  const {title, subtitle, footerText, disclaimer} = useMemo(
    () => getText(mq.MS_AND_DOWN, firstName, impostorModeContext.isImpostor),
    [impostorModeContext.isImpostor, mq.MS_AND_DOWN, firstName]
  );

  return (
    <BaseStep
      stepHeader={title}
      subHeader={subtitle}
      disclaimer={disclaimer}
      className="achievement-selection-step"
      required
    >
      <AchievementCards />
      <FooterTextWithEmoji emoji={Emojis.PARTY} text={footerText} />
    </BaseStep>
  );
}
